import React from 'react';
import { RewardHistoryRoutes } from './history/history.routes';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';
import { CompetitionRoutes } from './competitions/competition.routes';

export const RewardRoutes: BaseRoute[] = [
  {
    path: '/rewards/what-is-rewards',
    title: 'What is Rewards',
    name: 'whatIsRewards',
    feature: Feature.WhatIsRewards,
    component: React.lazy(() => import('./rewards-landing/rewards-landing')),
    protected: false,
  },
  {
    path: '/rewards/available-rewards',
    title: 'Available Rewards',
    name: 'availableRewards',
    feature: Feature.AvailableRewards,
    component: React.lazy(() => import('./available-rewards/available-rewards')),
    protected: true,
  },
  {
    path: '/rewards/access-exclusive-rewards',
    title: 'Access exclusive rewards',
    name: 'accessExclusiveRewards',
    feature: Feature.EarnMoreStars,
    component: React.lazy(() => import('./access-exclusive-rewards/access-exclusive-rewards')),
    protected: true,
  },
  {
    path: '/rewards/:rewardId',
    title: 'Reward Details',
    name: 'rewardDetails',
    feature: Feature.AvailableRewards,
    component: React.lazy(() => import('./reward-details/reward-details')),
    protected: true,
    hideFromMainMenu: true,
  },
  {
    path: '/rewards/competitions/*',
    title: 'Competitions',
    name: 'competitions',
    feature: Feature.Competitions,
    children: CompetitionRoutes,
    component: React.lazy(() => import('./competitions/competitions')),
    protected: false,
  },
  {
    path: '/rewards/history/*',
    title: 'Rewards History',
    name: 'rewardsHistory',
    feature: Feature.RewardsHistory,
    children: RewardHistoryRoutes,
    component: React.lazy(() => import('./history/history')),
    protected: true,
  }
];

export const PremiumRoutes = [
  {
    path: '/rewards/premium-status',
    title: 'My Premium Status"',
    name: 'rewardsPremiumStatus',
    feature: Feature.RewardsPremiumStatus,
    component: React.lazy(() => import('./premium/premium')),
    protected: true,
  },
  {
    path: '/rewards/what-is-premium',
    title: 'What is 100% Premium',
    name: 'rewardsWhatIsPremium',
    feature: Feature.RewardsWhatIsPremium,
    component: React.lazy(() => import('./premium/what-is-premium/what-is-premium')),
    protected: true,
  }
];